jQuery(document).ready(function ($) {
    var chartLanguage = $("html").attr("lang") === "nb-NO" ? "no" : "en";
    var defaultColors = ["#053775", "#00918f", "#C6D1E7", "#e82c2e", "#006362", "#dbd4d0"];
    var defaultBarColors = {
        blue: ["#89b5e5", "#89b5e5", "#89b5e5", "#89b5e5", "#1f2e4b"],
        green: ["#006362", "#006362", "#006362", "#006362", "#00B3B0"]
    };

    var hexToRgbA = function (hex) {
        var c;
        if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
            c = hex.substring(1).split("");
            if (c.length == 3) {
                c = [c[0], c[0], c[1], c[1], c[2], c[2]];
            }
            c = "0x" + c.join("");
            return (
                "rgba(" +
                [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") +
                ",0.35)"
            );
        }
        return hex;
    };

    var modifyForHover = function (colors) {
        var newColors = new Array();
        $.each(colors, function (key, value) {
            newColors.push(hexToRgbA(value));
        });
        return newColors;
    };

    var formatNumber = function ($string) {
        var newString = "";
        if (chartLanguage !== "no") {
            newString = $string;
        } else {
            var tStr = String($string);
            newString = tStr.replace(".", ",");
        }
        return newString;
    };

    var doCount = function (element) {
        return 1;
        if (!$(element).hasClass("counted")) {
            //var countDuration = ($(element).hasClass('quick')) ? 250 : (($(element).hasClass('medium')) ? 800 : 800);
            var countDuration = 800;
            var formattedNumber = $(element).attr("data-number-to-count");
            var numberSuffix = $(element).attr("data-number-to-count-suffix");
            var numberToCount = $(element).find("strong");
            if (typeof formattedNumber === "undefined") {
                formattedNumber = numberToCount.text().replace(",", ".");
                numberSuffix = formattedNumber
                    .replace(/\d+/g, "")
                    .replace(",", "")
                    .replace(".", "");
                $(element).attr("data-number-to-count", formattedNumber);
                $(element).attr("data-number-to-count-suffix", numberSuffix);
            }
            numberToCount.prop("Counter", 0).animate(
                {
                    Counter: formattedNumber
                },
                {
                    duration: countDuration,
                    easing: "swing",
                    step: function (now) {
                        var s = now.toString();
                        s = s.substr(
                            0,
                            s.indexOf(".") === -1 ? s.length : s.indexOf(".") + 2
                        );
                        s = formatNumber(s);
                        numberToCount.text(s + numberSuffix);
                    }
                }
            );
        }
        $(element).addClass("counted");
    };

    var currIsHover = false;
    var updatePieChartBackgroundColors = function (focusedPanel, isHover) {
        if (currIsHover === isHover) return;
        if (typeof focusedPanel === "undefined") return;
        var currChartId = focusedPanel.find("canvas").attr("id");
        var hoverBackgroundColorArray =
            isHover === true ? modifyForHover(defaultColors) : defaultColors;
        if (
            typeof loadedCharts !== "undefined" &&
            typeof loadedCharts[currChartId] !== "undefined"
        ) {
            var currChart = document.getElementById(
                focusedPanel.find("canvas").attr("id")
            );
            loadedCharts[
                currChartId
                ].data.datasets[0].backgroundColor = hoverBackgroundColorArray;
            loadedCharts[currChartId].update();
            loadedCharts[currChartId].render(500, false);
        }
        currIsHover = isHover;
    };

    var updateColorsTimeout = false;
    var selectedIndex = null;
    Chart.defaults.global.tooltips.custom = function (tooltip) {
        clearTimeout(updateColorsTimeout);
        var focusedPanel = $(".tabs-panel:focus, .tabs-panel:hover").first();
        if (focusedPanel.find(".chart-wrapper.pie").length === 0) return; // This ensures the changes are only applied to the pie chart type
        //tooltip.opacity = 0; // This hides the default tooltip

        if (
            typeof focusedPanel.find("h1.show-for-pie").attr("data-original-text") ===
            "undefined"
        ) {
            // Save original text to a data variable
            selectedIndex = null;
            focusedPanel
                .find("h1.show-for-pie")
                .attr(
                    "data-original-text",
                    focusedPanel.find("h1.show-for-pie").html()
                );
            focusedPanel.find("h1.show-for-pie").removeClass("quick");
            focusedPanel
                .find("p.show-for-pie")
                .attr("data-original-text", focusedPanel.find("p.show-for-pie").html());
            return;
        }

        // Hide if no tooltip
        if (tooltip.opacity === 0) {
            // Revert titles to original
            focusedPanel
                .find("h1.show-for-pie")
                .html(focusedPanel.find("h1.show-for-pie").attr("data-original-text"));
            focusedPanel
                .find("p.show-for-pie")
                .html(focusedPanel.find("p.show-for-pie").attr("data-original-text"));
            updateColorsTimeout = window.setTimeout(
                function (focusedPanel) {
                    updatePieChartBackgroundColors(focusedPanel, false);
                },
                250,
                focusedPanel
            );
            return;
        }

        function getBody(bodyItem) {
            return bodyItem.lines;
        }

        // Set Text
        if (tooltip.body) {
            var titleLines = tooltip.title || [];
            var bodyLines = tooltip.body.map(getBody);
            var hoverTitle = bodyLines[0][0].split(":")[0];
            var newValue = formatNumber(bodyLines[0][0].split(":")[1]);
            $(".tabs-panel.is-active:hover h1.show-for-pie strong").text(newValue);
            $(".tabs-panel.is-active:hover p.show-for-pie").html(hoverTitle);
            $(".tabs-panel.is-active:hover h1.show-for-pie")
                .removeClass("counted")
                .addClass("quick");
            //doCount($('.tabs-panel.is-active:hover h1.show-for-pie'));
        }

        //updateColorsTimeout = window.setTimeout(function(focusedPanel) {
        updatePieChartBackgroundColors(focusedPanel, true);
        //}, 200, focusedPanel);

        return;
    };

    var getChartOptionsByType = function (chartType, tabTitleElement) {

        ////////////// PIE CHART OPTIONS \\\\\\\\\\\\\\
        var options;

        if (chartType === "pie") {
            options = {
                responsive: false,
                width: 500,
                height: 500,
                cutoutPercentage: 82,
                legend: {
                    display: false
                },
                tooltips: {
                    display: false,
                    enabled: false
                },
                onHover: function (evt, elements) {
                    if (elements && elements.length) {
                        var segment = elements[0];
                        if (selectedIndex !== segment["_index"]) {
                            this.chart.update();
                            selectedIndex = segment["_index"];
                            segment._model.outerRadius += 12;
                        } else {
                            selectedIndex = null;
                        }
                    }
                },
                layout: {
                    padding: 30
                }
            };

            var data = {
                datasets: [
                    {
                        data: JSON.parse(tabTitleElement.attr("data-pie-value")),
                        backgroundColor: defaultColors,
                        hoverBorderColor: defaultColors,
                        hoverBackgroundColor: defaultColors,
                        borderWidth: 0,
                        hoverBorderWidth: 0,
                        radius: 0,
                        pointHoverRadius: 0
                    }
                ],
                labels: JSON.parse(tabTitleElement.attr("data-pie-label"))
            };
        }

        ////////////// BAR CHART OPTIONS \\\\\\\\\\\\\\
        else {
            options = {
                responsive: false,
                width: 550,
                beginAtZero: false,
                height: 500,
                legend: {
                    display: false
                },
                layout: {
                    padding: {
                        left: 0,
                        right: 20,
                        top: 100,
                        bottom: 50
                    }
                },
                scales: {
                    xAxes: [
                        {
                            gridLines: {
                                display: false,
                                drawBorder: false
                            },
                            ticks: {
                                autoSkip: false,
                                fontColor: "#051837",
                                fontSize: 16,
                                fontStyle: "bold",
                                fontFamily:
                                    "'Freizeit', 'Helvetica Neue', 'Arial', sans-serif"
                            }
                        }
                    ],
                    yAxes: [
                        {
                            gridLines: {
                                display: false,
                                drawBorder: false
                            },
                            ticks: {
                                display: false,
                                beginAtZero: false,
                                //min: -30,
                                //suggestedMin: -20,
                                //suggestedMax: 200,
                                //min: (tabTitleElement.attr("data-tab-slug") == "avkastning" || tabTitleElement.attr("data-tab-slug") == "return-on-equity") ? -2 : 8,
                                // steps: 10,
                                // stepValue: 0.5,
                                // min: 0.5 * (tabTitleElement.attr("data-max-value") / 10),
                                // max: parseInt(tabTitleElement.attr("data-max-value")),
                            },
                            scaleLabel: {
                                display: true,
                                labelString: tabTitleElement.attr("data-vertical-axis-label"),
                                fontColor: "#051837",
                                fontSize: 16,
                                padding: 10,
                                labelOffset: 10
                            }
                        }
                    ]
                },

                tooltips: {
                    mode: "nearest",
                    intersect: false,
                    filter: function (tooltipItem) {
                        return false; // disable tooltips
                        return tooltipItem.datasetIndex === 0; // Show tooltip only for first dataset
                    },
                    callbacks: {
                        title: function (tooltipItem, data) {
                            return false;
                        },
                        label: function (tooltipItem, data) {
                            var newLabel = formatNumber(
                                data["datasets"][tooltipItem["datasetIndex"]]["data"][
                                    tooltipItem["index"]
                                    ].replace(" ", "") + "%"
                            );
                            return newLabel;
                        }
                    },
                    backgroundColor: "#a59e76",
                    titleFontSize: 20,
                    titleFontStyle: "bold",
                    titleFontFamily: "FuturaBT-Medium",
                    titleFontColor: "#051837",
                    bodyFontSize: 20,
                    bodyFontStyle: "bold",
                    bodyFontFamily: "FuturaBT-Medium",
                    bodyFontColor: "#051837",
                    xPadding: 8,
                    yPadding: 8,
                    displayColors: false
                },

                hover: {
                    mode: "null",
                    intersect: true,
                    animationDuration: 0 // Prevents numbers from flashing
                },

                animation: {
                    duration: 1,
                    onComplete: function (e) {
                        var chartInstance = this.chart,
                            ctx = chartInstance.ctx;
                        ctx.fillStyle = "#051837";

                        this.data.datasets.forEach(function (dataset, i) {

                            if (i == 0) {
                                ctx.textBaseline = "bottom";
                                ctx.fontStyle = "bold";
                                var meta = chartInstance.controller.getDatasetMeta(i);
                                meta.data.forEach(function (bar, index) {
                                    //ctx.textAlign = index > 3 ? "left" : "center";
                                    ctx.textAlign = "center";
                                    var data = formatNumber(dataset.data[index]);
                                    data = data.replace(" ", "");
                                    //var fontSize = index <= 3 ? "14" : "21"; // HASAN
                                    var fontSize = "16";
                                    ctx.font = fontSize + 'px "Freizeit"';
                                    ctx.font = fontSize + "px Freizeit";
                                    // 2020 theme exception
                                    if (index == 4) ctx.fillStyle = "#ffffff"; // HASAN
                                    ctx.fillText(
                                        data + "%",
                                        // bar._model.x + 17,
                                        // bar._model.y + 15
                                        bar._model.x + 0,
                                        bar._model.y + -15
                                    );
                                });
                            } else if (i == 1) {
                                ctx.textAlign = "center";
                                ctx.textBaseline = "bottom";
                                ctx.fontStyle = "normal";
                                var meta = chartInstance.controller.getDatasetMeta(i);
                                meta.data.forEach(function (bar, index) {
                                    var data = formatNumber(dataset.data[index]);
                                    var fontSize = index <= 3 ? "18" : "18"; // revert to "18" : "33" if you want to higlight last bar
                                    var yOffset = index <= 3 ? 22 : 22; // revert to 22 : 15; if you want to higlight last bar
                                    ctx.font = fontSize + 'px "Freizeit"';
                                    ctx.font = fontSize + "px Freizeit";
                                    ctx.fillStyle = "#051837";
                                    ctx.fillText(data, bar._model.x, bar._model.y - yOffset);
                                });
                            } else {

                            }
                        });
                    }
                }
            };

            var data = {
                datasets: [
                    {
                        label: tabTitleElement.attr("data-line-graph-title"),
                        type: "line",
                        fill: false,
                        borderColor: "#00b3b0",
                        pointBackgroundColor: "#ffffff",
                        pointBorderWidth: 3,
                        radius: 6,
                        pointRadius: 6,
                        pointHoverRadius: 9
                    },
                    {
                        label: tabTitleElement.attr("data-bar-graph-title"),
                        type: "bar",
                        data: JSON.parse(tabTitleElement.attr("data-bar-value")),
                        backgroundColor: defaultBarColors[tabTitleElement.attr("data-bar-graph-color")]
                    }
                ],
                labels: JSON.parse(tabTitleElement.attr("data-bar-graph-labels"))
            };
        }

        /**
         * FOR SECOND GRAPH, INCLUDE STACKED GRAPH WITH SAME STYLES
         * AND NEGATIVE VALUES IN ORDER TO EMULATE THE ORIGINAL BARS TO EXTEND BELOW 0
         */
        var tabSlug = tabTitleElement.attr("data-tab-slug");

        if ( tabSlug === "avkastning" || tabSlug === "return-on-equity" ) {
            options.scales.xAxes[0].stacked = true;
            options.scales.yAxes[0].stacked = true;
            data.datasets.push({
                label: false,
                type: "bar",
                data: [-20, -20, -20, -20, -20],
                backgroundColor: defaultBarColors[tabTitleElement.attr("data-bar-graph-color")]
            });
        } else if ( tabSlug === "likviditet" || tabSlug === "liquidity" ) {
            options.scales.xAxes[0].stacked = false;
            options.scales.yAxes[0].stacked = false;
            options.scales.yAxes[0].ticks.min = -2;
            data.datasets.slice(0, -1);
        }

        if (tabTitleElement.attr("data-line-value")) {
            data.datasets[0].data = JSON.parse(tabTitleElement.attr("data-line-value"));
        }

        return {
            type: chartType,
            data: data,
            options: options
        };
    };

    var loadedCharts = [];
    var lastLoadedChartId = false;
    var chartCanvasRadius = 450;
    var loadChart = function (ctx, tabTitleElement) {
        //ctx.height = 350;
        var chartType = tabTitleElement.attr("data-chart-type");
        if (typeof chartType === "undefined") {
            chartType = "pie";
        }
        var chartOptions = getChartOptionsByType(chartType, tabTitleElement);
        var chart = new Chart(ctx, chartOptions);
        var chartWrapper = ctx.closest(".chart-wrapper");
        chartWrapper.removeClass();
        chartWrapper.addClass("chart-wrapper " + chartType);
        chartWrapper.css("min-height", "auto");
        if (tabTitleElement.attr("data-bar-graph-color") === "green") {
            chartWrapper
                .closest(".tabs-panel")
                .removeClass("blue")
                .addClass("green");
        } else {
            chartWrapper
                .closest(".tabs-panel")
                .removeClass("green")
                .addClass("blue");
        }
        $(".show-for-" + chartType).addClass("visible");
        //doCount(chartWrapper.find('.show-for-' + chartType));
        loadedCharts[ctx.attr("id")] = chart;
        lastLoadedChartId = ctx.attr("id");
    };

    var doChartResize = function () {
        chartCanvasRadius = $(window).width() <= 600 ? 380 : 450;
        //$('.chart-wrapper canvas').width(chartCanvasRadius).height(chartCanvasRadius);
    };

    var prepareChart = function (tabTitleElement) {
        doChartResize();
        var contentTabId = tabTitleElement.attr("href");
        var ctx = $(contentTabId).find("canvas");
        var currChart = $("#" + ctx.attr("id"));
        currChart
            .closest(".chart-wrapper")
            .css("min-height", currChart.closest(".chart-wrapper").height());
        if (
            typeof loadedCharts === "undefined" ||
            typeof loadedCharts[ctx.attr("id")] === "undefined"
        ) {
            loadChart(ctx, tabTitleElement);
        }
    };

    $(".tabs-graphs .tabs-title.is-active").each(function () {
        // load initial chart
        prepareChart($(this).find("a"));
    });

    doChartResize();
    var chartResizeTimeout = false;
    $(window).resize(function () {
        clearTimeout(chartResizeTimeout);
        chartResizeTimeout = window.setTimeout(doChartResize, 250);
    });

    $(document)
        /*
        .on('click', '.toggle-chart-type:not(.disabled)', function(e) {
            e.preventDefault();
            if ($(this).hasClass('active')) return;
            $(this).closest('.tabbed-info').find('.toggle-chart-type.active').removeClass('active');
            $(this).addClass('active');
            $(this).closest('.tabbed-info').find('.tabs-title a').each(function() {
                prepareChart($(this));
            });
            var activePanel = $(this).closest('.tabbed-info').find('.tabs-panel.is-active');
            activePanel.find('.counted').removeClass('.counted');
            doCount(activePanel.find('.countable'));
            //prepareChart(currTabTitleElement);
            var currTabTitleElement = $(this).closest('.tabbed-info').find('.tabs-title.is-active a');
            var gtmEventLabel = currTabTitleElement.text() + ' (' + activePanel.closest('.tabbed-info').find('.toggle-chart-type.active').text() + ')';
            customGtmEvent('changeGraphFigure', gtmEventLabel );
        })
        */
        .on("change.zf.tabs", ".tabs-graphs .tabs", function () {
            var currTabTitleElement = $(this)
                .closest(".tabbed-info")
                .find(".tabs-title.is-active a");
            var canvases = $(this)
                .closest(".tabbed-info")
                .find("canvas");
            canvases.fadeOut(0);
            /*
              // Toggle visibility of top data type buttons
              var chartTypeToggleButtons = currTabTitleElement.closest('.flexible-content').find('.chart-type-buttons');
              if (currTabTitleElement.attr('data-no-graph')=='true') {
                  chartTypeToggleButtons.find('a').first().trigger('click');
                  chartTypeToggleButtons.addClass('disabled');
              } else {
                  chartTypeToggleButtons.removeClass('disabled');
              }
              */
            // Check if chart loaded
            var contentTabId = currTabTitleElement.attr("href");
            $(contentTabId + " .counted").removeClass("counted");
            var ctx = $(contentTabId).find("canvas");
            canvases.fadeIn(0);
            var chartType = currTabTitleElement.attr("data-chart-type");
            if (typeof chartType === "undefined") {
                chartType = "pie";
            }
            if (chartType === "pie") {
                $(".bar-graph-legend").fadeOut(0);
            } else {
                $(".bar-graph-legend").fadeIn(0);
            }
            if (
                typeof loadedCharts !== "undefined" &&
                typeof loadedCharts[ctx.attr("id")] === "undefined"
            ) {
                prepareChart(currTabTitleElement);
            } else {
                $(".show-for-pie.visible, .show-for-bar.visible").removeClass(
                    "visible"
                );
                $(".show-for-" + chartType).addClass("visible");
            }
            $(contentTabId + " .counted").removeClass("counted");
            doCount($(contentTabId + " .countable"));
            var gtmEventLabel = currTabTitleElement.text();
            customGtmEvent("viewGraphFigure", gtmEventLabel);
        })
        .on("change.zf.tabs", ".tabs-text .tabs", function () {
            var currTabTitleElement = $(this)
                .closest(".tabbed-info")
                .find(".tabs-title.is-active a");
            // Check if chart loaded
            var contentTabId = currTabTitleElement.attr("href");
            $(contentTabId + " .counted").removeClass("counted");
            doCount($(contentTabId + " .countable"));
            customGtmEvent("viewTextSection", currTabTitleElement.text());
        });

    var lastEventLabelSent = false;

    function customGtmEvent(eventName, eventLabel) {
        window.dataLayer = window.dataLayer || [];
        if (eventLabel + eventName === lastEventLabelSent) return; // Prevent same label being sent twice in a row
        lastEventLabelSent = eventLabel + eventName;
        window.dataLayer.push({
            event: eventName,
            eventLabel: eventLabel
        });
    }

    $("body").on("section-reached", function () {
        if (typeof $("body").sectionScroll.activeSection === "undefined") return;
        var currSection = $("body").sectionScroll.activeSection;
        if (
            currSection.hasClass("tabbed-info") &&
            !currSection.hasClass("has-been-viewed")
        ) {
            if (currSection.hasClass("tabs-graphs")) {
                customGtmEvent(
                    "viewGraphFigure",
                    currSection.find(".tabs-title.is-active a").text()
                );
            } else if (currSection.hasClass("tabs-text")) {
                customGtmEvent(
                    "viewTextSection",
                    currSection.find(".tabs-title.is-active a").text()
                );
            }
            currSection.addClass("has-been-viewed");
            currSection.find(".counted").removeClass("counted");
            doCount(currSection.find(".tabs-panel.is-active .countable").first());
        }
    });
});
